import React from 'react';
import styled from 'styled-components';

export type CardState = 'none' | 'in progress' | 'success' | 'error';

export type CardProps = {
  className?: string;
  children: React.ReactNode;
  progressBar?: { current: number; total: number };
  state?: CardState;
  maxWidth?: string;
};

const StyledCard = styled.div<{ $maxWidth?: string }>`
  display: flex;
  padding: 32px;
  max-width: ${({ $maxWidth }) => $maxWidth};
  flex-direction: column;
  align-items: center;
  gap: 48px;
  flex-shrink: 0;
  border-radius: var(--border-radius-large);
  background: var(--white);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
  position: relative;
`;

const BASE_STRIP_HEIGHT = 6;

const BaseStrip = styled.div`
  width: 100%;
  height: ${BASE_STRIP_HEIGHT}px;
  border-radius: ${BASE_STRIP_HEIGHT}px ${BASE_STRIP_HEIGHT}px 0 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

const ProgressBarContainer = styled(BaseStrip)`
  background: var(--light-purple);
  overflow: hidden;
`;

const ProgressBarFill = styled.div<{ $percent: number }>`
  height: 100%;
  background: var(--purple);
  width: ${({ $percent }) => $percent}%;
  transition: width 0.3s;
`;

const StateStrip = styled(BaseStrip)<{ $color: string }>`
  background: ${({ $color }) => $color};
`;

export const Card = ({ className, children, progressBar, state = 'none', maxWidth = '489px' }: CardProps) => {
  let topBar = null;
  if (state === 'in progress' && progressBar) {
    topBar = (
      <ProgressBarContainer>
        <ProgressBarFill $percent={Math.max(0, Math.min(100, (progressBar.current / progressBar.total) * 100))} />
      </ProgressBarContainer>
    );
  } else if (state === 'success') {
    topBar = <StateStrip $color="var(--green)" />;
  } else if (state === 'error') {
    topBar = <StateStrip $color="var(--red)" />;
  }
  return (
    <StyledCard className={className} $maxWidth={maxWidth}>
      {topBar}
      <div>{children}</div>
    </StyledCard>
  );
};

export default Card;
